<template>
  <div class="app-header">
    <div class="container">
      <div class="logo"><img src="@/assets/logo.png" alt="TP-LINK logo" class="logo-img">Customer Satisfaction Survey</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppHeader'
};
</script>

<style>
.app-header {
  padding: 20px 0 10px 0;
  margin-bottom: 40px;
  background-color: #fff;
  box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.1);
}

.app-header .logo {
  font-size: 20px;
}
.app-header .logo-img {
  height: 41px;
  width: auto;
  margin-right: 15px;
  margin-bottom: 10px;
  vertical-align: middle;
}

</style>
